import { PERMISSION_TYPES, type PermissionEntityScope, type PermissionType, type ScopeWithSource } from '../model'
import { isEmpty } from './isEmpty'

export function isPermissionType(val: unknown): val is PermissionType {
  return PERMISSION_TYPES.some((p) => p === val)
}

export const SCOPE_LEVELS: Record<PermissionEntityScope, number> = {
  company: 4,
  withinRestrictions: 3,
  downline: 2,
  self: 1,
  none: 0,
}

export function pickHighestPermissionScope(scopes: ScopeWithSource[] | undefined): ScopeWithSource | undefined {
  if (isEmpty(scopes)) return
  return scopes.reduce((highest, current) => {
    if (SCOPE_LEVELS[highest.entity] < SCOPE_LEVELS[current.entity]) return current
    return highest
  })
}

export function sortPermissionOptions(permissions: PermissionEntityScope[]): PermissionEntityScope[] {
  return permissions.sort((a, b) => SCOPE_LEVELS[b] - SCOPE_LEVELS[a])
}

export function getPermissionScopeRank(scope: PermissionEntityScope): number {
  return SCOPE_LEVELS[scope]
}
